
import * as React from 'react';
import { BaseComponent, BaseComponentState, BaseComponentProps } from '../base/BaseComponent';
import { isNull } from '../utils/index';
export interface ColapsePanelProps extends BaseComponentProps {
    colapse: boolean;
    title: string;
    component: any;
    border?: boolean;
    panel?: boolean;
    className?: string;
}
export interface ColapsePanelState extends BaseComponentState {
    searchColapse: boolean;
    copalseIcon: any;
    searchClassname: string;
    checkbox: any;
}
export class ColapsePanel extends BaseComponent<ColapsePanelProps, ColapsePanelState> {
    constructor(props: ColapsePanelProps) {
        super(props);
        this.state = {
            searchColapse: props.colapse,
            copalseIcon: <i className="ti-minus" />,
            searchClassname: '',
            checkbox: []
        };
    }

    componentDidMount() {
        this.colapse();
    }

    colapse: () => any = () => {
        // console.log(this.props.title, this.state.searchColapse)
        this.setState(prv => {
            let vsearchColapse = false;
            let vcopalseIcon = <i className="ti-minus" />;
            let vsearchClassname = ' ';
            if (!this.state.searchColapse) {
                vsearchColapse = true;
                vcopalseIcon = <i className="ti-plus" />;
                vsearchClassname = 'hide';
            }
            return { searchColapse: vsearchColapse, copalseIcon: vcopalseIcon, searchClassname: vsearchClassname };
        });
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        // console.log(this.props.component)
        let border = 'border-light';
        let panel = 'panel panel-white';
        if (!isNull(this.props.border) && this.props.border === false) {
             border = '';
        }
        if (!isNull(this.props.panel) && this.props.panel === false) {
            panel = '';
       }
        return (
            <div className={`${panel} ${isNull(this.props.className) ? '' : this.props.className}`} id="panel1">
                <div className={"panel-heading " + border}>
                    <h3 className="panel-title text-primary">{this.props.title}</h3>
                    <div className="panel-tools" >
                        <a
                            data-original-title="Collapse"
                            data-toggle="tooltip"
                            data-placement="top"
                            className="btn btn-transparent btn-sm"
                            onClick={(event) => { this.colapse(); }}
                        > {this.state.copalseIcon}
                        </a>
                    </div>
                </div>
                <div className={'panel-body ' + this.state.searchClassname}>
                    {this.props.component}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ColapsePanel.tsx